import React from "react"

/**
 * A small boxed text marker component, typically used for labels like "BETA", "NEW", etc.
 *
 * @param {Object} props
 * @param {string} props.text - The text to display (will be uppercase)
 * @returns {JSX.Element}
 */
export default function BoxedMarker({ text }) {
  return (
    <div className="boxed-marker">
      <span>{text}</span>
    </div>
  )
}
